<script setup>
  import { Layers2 } from "lucide-vue-next";
  import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
  import { Button } from "@/components/ui/button";
  import { useRecodeTypeItems } from "@/composables/useRecodeTypeItems";

  const open = defineModel("open", { type: Boolean, default: false });
  const emit = defineEmits(["select"]);

  const { availableRecodeItems } = useRecodeTypeItems();

  function select(key) {
    emit("select", key);
    open.value = false;
  }
</script>

<template>
  <Dialog v-model:open="open">
    <DialogContent class="overflow-hidden p-0 max-w-md flex flex-col">
      <DialogHeader class="px-4 pt-4 pb-3 border-b shrink-0">
        <DialogTitle class="heading-title">Add recode</DialogTitle>
        <DialogDescription class="sr-only">Choose a recode type</DialogDescription>
      </DialogHeader>

      <div class="px-2 py-2">
        <Button
          v-for="item in availableRecodeItems"
          :key="item.key"
          variant="ghost"
          class="w-full h-auto justify-start gap-2.5 px-2 py-1.5 text-left"
          @click="select(item.key)">
          <div class="flex h-7 w-7 shrink-0 items-center justify-center rounded bg-status-warning-soft">
            <Layers2 class="h-3.5 w-3.5 text-status-warning-strong" />
          </div>
          <div class="flex-1 min-w-0">
            <div class="flex items-baseline gap-2">
              <span class="text-13 font-medium">{{ item.name }}</span>
              <span class="text-xs text-muted-foreground truncate">{{ item.description }}</span>
            </div>
          </div>
        </Button>
      </div>
    </DialogContent>
  </Dialog>
</template>
